<div class="flex-layout center-content">
  <div class="ops-header item-grow">
    <a routerLink="/operational-dashboard/upcoming-orders">Upcoming Orders</a>
  </div>
</div>

<div class="main-container">
  <!-- styling goes over chart a bit...but it will disappear once it grabs data originally -->
  @if (isLoading) {
    <insight-loading-spinner class="text-center" style="position: absolute; z-index: 1; width: 100%; top: 13.5rem; "
      [loadingMessage]="'Loading...'"
      >
    </insight-loading-spinner>
  }

  @if (didError) {
    <div class="flex-layout center-content">
      <div>
        An error occurred while getting order shipments.
      </div>
    </div>
  }

  @if (!isLoading) {
    <div class="flex-layout column stretch-items">
      <legend-item [legendItems]="legendItems" (selectionChangedEvent)="updateFilteredChartData()">
      </legend-item>
      <div class="chart-container">
        <ngx-charts-bar-vertical-stacked [scheme]="chartColors"
          [results]="filteredChartData"
          [gradient]="false"
          [xAxis]="true"
          [yAxis]="true"
          [legend]="false"
          [showXAxisLabel]="true"
          [showYAxisLabel]="true"
          [xAxisLabel]="xAxisLabel"
          [yAxisLabel]="yAxisLabel"
          [animations]="true">
        </ngx-charts-bar-vertical-stacked>
      </div>
    </div>
  }
</div>
